module.exports = __webpack_public_path__ + "img/head_portrait.8597df0b.png";